import { connect } from 'react-redux'

import PrivateRoute from './PrivateRoute'

const mapStateToProps = state => {
  return {
    user: state.user.user,
    location: state.router.location,
    isWidgetState: state.appReducer.isWidget,
  }
}

export default connect(mapStateToProps, null)(PrivateRoute)
